<main role="main" aria-labelledby="page-title">
    <div class="heading">
        <h2 id="page-title" [ngClass]="{ required: !noAvailableDates }">Select date for your first clean</h2>
        <p *ngIf="!noAvailableDates" class="info-text" role="status">
            <span class="info-mark"></span><span>The first available date is selected below.</span>
        </p>
    </div>
    <div class="calendar-wrapper" [ngClass]="{ disabled: noAvailableDates }">
        <div class="disabled-plug" *ngIf="noAvailableDates">
            <ng-container *ngIf="!serverError">
                <h3>No available dates</h3>
                <p>
                    We’re sorry! It looks like there’s no upcoming availability through online
                    scheduling. <br />
                    We can likely still make your clean work with a quick call to our office.
                </p>
            </ng-container>
            <ng-container *ngIf="serverError">
                <h3>Our scheduling is currently unavailable.</h3>
                <p>
                    Please contact our office during business hours <br />
                    to schedule directly with our team.
                </p>
            </ng-container>
            <div class="btn-holder">
                <button id="contactMeBtn" (click)="openContactDialog('date')" class="action-btn">
                    <img src="/assets/images/call-in-icon.svg" alt="" role="presentation" width="16" height="16" />
                    <span>Contact me!</span>
                </button>
                <a
                    gaEvent="call_us_btn_clicked"
                    gaCategory="call_us"
                    gaLabel="Call us now"
                    [href]="'tel:' + locationPhone"
                    *ngIf="locationPhone"
                    class="link-btn"
                    [attr.aria-label]="'Call us at ' + locationPhone"
                >
                    <img src="/assets/images/call-out-icon.svg" alt="" role="presentation" width="16" height="16" />
                    <span>Call us now {{ locationPhone }}</span>
                </a>
            </div>
        </div>
        <ngb-datepicker
            #dp
            [(ngModel)]="selectedDate"
            (ngModelChange)="onModelChange($event)"
            [displayMonths]="displayMonths"
            [navigation]="navigation"
            [outsideDays]="outsideDays"
            [firstDayOfWeek]="firstDayOfWeek"
            [dayTemplate]="dayTemplate"
            [minDate]="minDate"
            [maxDate]="maxDate"
        />
        <ng-template #dayTemplate let-date="date" let-selected="selected" let-booked="booked">
            <div
                class="custom-day"
                [class.holiday]="isHoliday(date)"
                [class.booked]="isDateBooked(date)"
                [class.past]="isPast(date)"
                [class.selected]="isDateSelected(date)"
                [class.end-of-week]="isEndOfWeek(date)"
                (click)="onDateSelect(date, $event, isDisabled(date))"
            >
                {{ date.day }}
                <span *ngIf="isHoliday(date)" class="tooltip" container="body">
                    Date is unavailable for online due to holiday.<br />
                    Please contact our office for options.
                </span>
                <span
                    *ngIf="isDateBooked(date) && !isHoliday(date)"
                    class="tooltip"
                    container="body"
                >
                    Date is unavailable for online scheduling.<br />
                    Please contact our office for options.
                </span>
            </div>
        </ng-template>
        <div class="calendar-footer" *ngIf="!noAvailableDates">
            <p class="text">Having trouble finding a date you are looking for?</p>
            <div class="btn-holder">
                <button id="contactMeBtn" (click)="openContactDialog('date')" class="action-btn">
                    <img src="/assets/images/call-in-icon.svg" alt="" role="presentation" width="16" height="16" />
                    <span>Contact me!</span>
                </button>
                <a
                    gaEvent="call_us_btn_clicked"
                    gaCategory="call_us"
                    gaLabel="Call us now"
                    [href]="'tel:' + locationPhone"
                    *ngIf="locationPhone"
                    class="link-btn"
                    [attr.aria-label]="'Call us at ' + locationPhone"
                >
                    <img src="/assets/images/call-out-icon.svg" alt="" role="presentation" width="16" height="16" />
                    <span>Call us now {{ locationPhone }}</span>
                </a>
            </div>
        </div>
    </div>
    <p class="info-text navigation-info" role="status">
        <span class="info-mark"></span
        ><span>Changing any details provided may impact first clean date availability</span>
    </p>
</main>

<app-contact-dialog
    [isOpen]="isContactDialogOpen"
    [data]="contactDialogData"
    (closeDialog)="onContactDialogClosed($event)"
    (updateDialogState)="refreshTrapFocusInDialog('contactDialog')"
></app-contact-dialog>
